import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { logout, selectProviderAuth } from "../../auth-provider/slice/providerAuth";

const isTokenValid = () => {
  const expiryTime = localStorage.getItem("provider_token_expiry");
  if (!expiryTime) return false;

  const currentTime = new Date().getTime();
  return currentTime < parseInt(expiryTime);
};

const unprotectedPaths = ["/provider/panel/info", "/provider/panel/verify", "/provider/panel", "/provider/chat/client"]; // allow unverified users here

const ProviderMiddleware = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isProviderLoggedIn = useSelector(selectProviderAuth);
  const isVerified = useSelector((state) => state.providerInfo.isVerified); // from your earlier state
  const tokenValid = isTokenValid();

  const shouldRedirectToLogin = !isProviderLoggedIn || !tokenValid;
  const isUnverifiedAccessingProtectedPage =
  !isVerified && !unprotectedPaths.some(path => location.pathname.startsWith(path));

  if (shouldRedirectToLogin) {
    dispatch(logout());
    localStorage.removeItem("provider_access_token");
    localStorage.removeItem("provider_token_expiry");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_name");

    return <Navigate to="/provider/signin" replace />;
  }

  if (isUnverifiedAccessingProtectedPage) {
    return <Navigate to="/provider/panel/verify" replace />;
  }

  return children;
};

ProviderMiddleware.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProviderMiddleware;
